import { getRuntimeEnv } from '@imagise/shared';
import type { GLProbe } from '@imagise/shared';

type TCopyPasteData = Record<string, unknown>;

export type TCanvasEnv = {
  document: Document;
  window: Window & typeof globalThis;
  isTouchSupported: boolean;
  WebGLProbe: GLProbe;
  dispose: (element: Element) => void;
  copyPasteData: TCopyPasteData;
};

const copyPasteData: TCopyPasteData = {};

let env: TCanvasEnv | undefined;

/**
 * The canvas environment is built on top of the shared runtime-env: document/window,
 * the WebGL probe (WebGL2 with a WebGL1 fallback in the browser, no-op in Node) and
 * dispose come from a single source for both browser and SSR.
 */
const createEnv = (): TCanvasEnv => {
  const runtimeEnv = getRuntimeEnv();

  return {
    document: runtimeEnv.document,
    window: runtimeEnv.window,
    isTouchSupported: runtimeEnv.isTouchSupported,
    WebGLProbe: runtimeEnv.WebGLProbe,
    dispose: runtimeEnv.dispose,
    copyPasteData,
  };
};

export const setEnv = (value: TCanvasEnv): void => {
  env = value;
};

export const getEnv = (): TCanvasEnv => {
  if (!env) {
    env = createEnv();
  }
  return env;
};

export const getCanvasDocument = (): Document => getEnv().document;

export const getCanvasWindow = (): Window & typeof globalThis => getEnv().window;
